import React from 'react';
import { cn } from '../lib/utils';

interface NovalaLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  centered?: boolean;
}

export function NovalaLogo({ size = 'md', className, centered }: NovalaLogoProps): React.ReactElement {
  const sizeClass = size === 'sm' ? 'h-6' : size === 'lg' ? 'h-14' : 'h-8';
  const img = (
    <img
      src="/logo-full-green.svg"
      alt="Novala"
      className={cn(sizeClass, 'w-auto object-contain select-none', centered && 'mx-auto', className)}
      draggable={false}
    />
  );
  if (centered) {
    return <div className="mb-6 text-center">{img}</div>;
  }
  return img;
}
